import { render, staticRenderFns } from "./EditProcess.vue?vue&type=template&id=056fdb4c&scoped=true&"
import script from "./EditProcess.vue?vue&type=script&lang=js&"
export * from "./EditProcess.vue?vue&type=script&lang=js&"
import style0 from "./EditProcess.vue?vue&type=style&index=0&id=056fdb4c&prod&scoped=true&lang=css&"
import style1 from "./EditProcess.vue?vue&type=style&index=1&id=056fdb4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056fdb4c",
  null
  
)

export default component.exports